import React, { Fragment } from "react";

import { PropTypes } from "prop-types";

import { Box, Divider, Stack, Typography } from "@mui/material";

import {
  CheckBoxField,
  CustomField,
  DateField,
  DropdownField,
  MultiSelectField,
  NumberInputField,
  SubtitleField,
  ToggleField,
  CharsInputField,
  GoogleAddressInputField,
  FormListField,
} from "./CustomFormFields";
import { isFunction } from "../../shared/utils/utils";

const getFieldHtml = (
  field,
  form,
  setForm,
  template,
  showMissingFields,
  wrap = true,
) => {
  switch (field.type) {
    case "toggle":
      return (
        <ToggleField
          field={field}
          form={form}
          setForm={setForm}
          template={template}
          showMissingFields={showMissingFields}
          wrap={wrap}
        />
      );
    case "input_number":
      return (
        <NumberInputField
          field={field}
          form={form}
          setForm={setForm}
          template={template}
          showMissingFields={showMissingFields}
          wrap={wrap}
        />
      );
    case "input_chars":
      return (
        <CharsInputField
          field={field}
          form={form}
          setForm={setForm}
          template={template}
          showMissingFields={showMissingFields}
          wrap={wrap}
        />
      );
    case "address":
      return (
        <GoogleAddressInputField
          field={field}
          form={form}
          setForm={setForm}
          template={template}
          showMissingFields={showMissingFields}
          wrap={wrap}
        />
      );
    case "dropdown":
      return (
        <DropdownField
          field={field}
          form={form}
          setForm={setForm}
          template={template}
          showMissingFields={showMissingFields}
          wrap={wrap}
        />
      );
    case "multiselect":
      return (
        <MultiSelectField
          field={field}
          form={form}
          setForm={setForm}
          template={template}
          showMissingFields={showMissingFields}
          wrap={wrap}
        />
      );
    case "date":
      return (
        <DateField
          field={field}
          form={form}
          setForm={setForm}
          template={template}
          showMissingFields={showMissingFields}
          wrap={wrap}
        />
      );
    case "checkbox":
      return (
        <CheckBoxField
          field={field}
          form={form}
          setForm={setForm}
          template={template}
          showMissingFields={showMissingFields}
          wrap={wrap}
        />
      );
    case "custom":
      return (
        <CustomField
          field={field}
          form={form}
          setForm={setForm}
          template={template}
          showMissingFields={showMissingFields}
          wrap={wrap}
        />
      );
    case "subtitle":
      return (
        <SubtitleField
          field={field}
          form={form}
          setForm={setForm}
          template={template}
          showMissingFields={showMissingFields}
          wrap={wrap}
        />
      );
    case "formlist":
      return (
        <FormListField
          field={field}
          form={form}
          setForm={setForm}
          template={template}
          showMissingFields={showMissingFields}
          wrap={wrap}
        />
      );
    default:
      return null;
  }
};

export default function CustomForm({
  title,
  template,
  form,
  setForm,
  showMissingFields,
}) {
  const elements = template
    .filter((field) => !field.condition || field.condition(form))
    .filter(
      (field) => !(isFunction(field.hide) ? field.hide(form) : field.hide),
    )
    .map((field) => {
      const html = getFieldHtml(
        field,
        form,
        setForm,
        template,
        showMissingFields,
        !field.htmlWrapper,
      );
      return field.htmlWrapper ? field.htmlWrapper(html, form) : html;
    })
    .filter((i) => i);
  return (
    <Box style={{ marginTop: "10px" }}>
      {title ? (
        <>
          <Typography fontSize="h4.fontSize" color="primary">
            {title}
          </Typography>
          <Divider sx={{ bgcolor: "primary.main", marginTop: 2 }} />
        </>
      ) : null}
      <Stack direction="column" spacing={2}>
        {elements.map((element, eidx) => (
          <Fragment key={`custom-form-element-${eidx}`}>{element}</Fragment>
        ))}
      </Stack>
    </Box>
  );
}

CustomForm.propTypes = {
  title: PropTypes.string,
  template: PropTypes.arrayOf(PropTypes.object),
  form: PropTypes.object,
  setForm: PropTypes.func,
  showMissingFields: PropTypes.bool,
};
